$(document).ready(function () {
  // Video Poster Js
  $(".itg_vid video").Lazy();

  // Featured Collection Slider
  var swiper_product = new Swiper(".product_grid", {
    slidesPerView: 4,
    spaceBetween: 10,
    pagination: {
      el: ".product_grid .swiper-pagination",
      type: "progressbar",
    },
    navigation: {
      nextEl: ".product_grid .button-next",
      prevEl: ".product_grid .button-prev",
    },
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      // when window width is >= 480px
      750: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      // when window width is >= 640px
      990: {
        slidesPerView: 4,
        spaceBetween: 40,
      },
    },
  });

  // Image with collection slider
  var swiper = new Swiper(".product_grid_iwc", {
    cssMode: true,
    navigation: {
      nextEl: ".img_coll_swiper .button-next",
      prevEl: ".img_coll_swiper .button-prev",
    },
    pagination: {
      el: ".img_coll_swiper .swiper-pagination",
      clickable: true,
    },
    mousewheel: true,
    keyboard: true,
  });

  // Blog Slider
  var swiper_product = new Swiper(".blog_swiper", {
    slidesPerView: 2,
    spaceBetween: 30,
    pagination: {
      el: ".blog_swiper .swiper-pagination",
      type: "progressbar",
    },
    navigation: {
      nextEl: ".blog_swiper .button-next",
      prevEl: ".blog_swiper .button-prev",
    },
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      // when window width is >= 480px
      950: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
    },
  });

  // Product Page Show Hide
  $(document).on("click", ".read_more", function () {
    $(this).parents(".main_desc").hide();
    $(".full_des").fadeIn("500");
  });
  $(document).on("click", ".read_less", function () {
    $(this).parents(".full_des").hide();
    $(".main_desc").fadeIn("500");
  });

  // Product Page Tab

  // Show the first tab and hide the rest
  $("#tabs-nav li:first-child").addClass("active");
  $(".tab-content").hide();
  $(".tab-content:first").show();

  // Click function
  $("#tabs-nav li").click(function () {
    $("#tabs-nav li").removeClass("active");
    $(this).addClass("active");
    $(".tab-content").hide();

    var activeTab = $(this).find("a").attr("href");
    $(activeTab).fadeIn();
    return false;
  });


  // if the product is a testing kit
  if ($('.product-form__submit').length > 0 && $('.CustonAddTocart').length > 0) {
    // Product testing kit form
    $(document).on(
      "click",
      ".product-form__submit, .CustonAddTocart",
      function (e) {
        var consent_forms_value = undefined;
        var consent_forms = document.getElementById("consent_forms");
        if (consent_forms) consent_forms_value = consent_forms.value;
  
        var consent_date_element = document.getElementById("consent_date");
        if (consent_date_element) consent_date_element.value = new Date();
  
        var first_name = $("#first-name").val();
        var last_name = $("#last-name").val();
        var email = $("#email").val();
        var guardian_email = $("#guardian_email").val();
        //  var height = $("#height").val();
        //  var weight = $("#weight").val();
        var driverlicence = $("#driverlicence").val();
        var mailformat = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
        var patient_phone = $("#patient-phone").val();
        var month = $("#month option:selected").val();
        var day = $("#day option:selected").val();
        var year = $("#year option:selected").val();
        var gender = $("#gender option:selected").val();
        var address = $("#address").val();
        var city = $("#city").val();
        var zip_code = $("#zip-code").val();
        var state = $("#state option:selected").val();
        var country = $("#country option:selected").val();
        var consent_first_name = $("#consent_first_name");
        var consent_last_name = $("#consent_last_name");
  
        var consent_checkbox = document.querySelector(".consent_given");
        if (consent_checkbox && !consent_checkbox.checked) {
          $(".consents").show();
          e.preventDefault();
        }
  
        if (consent_first_name && consent_first_name.val() == "") {
          $("#consent_first_name").addClass("error_msg");
          $(".hide").slideDown();
          e.preventDefault();
        } else {
          $("#consent_first_name").removeClass("error_msg");
        }
  
        if (consent_last_name && consent_last_name.val() == "") {
          $("#consent_last_name").addClass("error_msg");
          $(".hide").slideDown();
          e.preventDefault();
        } else {
          $("#consent_last_name").removeClass("error_msg");
        }
  
        if (first_name == "") {
          $("#first-name").addClass("error_msg");
          $(".hide").slideDown();
          e.preventDefault();
        } else {
          $("#first-name").removeClass("error_msg");
        }
  
        if (last_name == "") {
          $("#last-name").addClass("error_msg");
          $(".hide").slideDown();
          e.preventDefault();
        } else {
          $("#last-name").removeClass("error_msg");
        }
  
        // if (height == "") {
        //   $("#height").addClass("error_msg");
        //   $(".hide").slideDown();
        //   e.preventDefault();
        // } else {
        //   $("#height").removeClass("error_msg");
        // }
  
        // if (weight == "") {
        //   $("#weight").addClass("error_msg");
        //   $(".hide").slideDown();
        //   e.preventDefault();
        // } else {
        //   $("#weight").removeClass("error_msg");
        // }
  
        if (driverlicence == "") {
          $("#driverlicence").addClass("error_msg");
          $(".hide").slideDown();
          e.preventDefault();
        } else {
          $("#driverlicence").removeClass("error_msg");
        }
  
        if (email == "") {
          $("#email").addClass("error_msg");
          $(".hide").slideDown();
          e.preventDefault();
        } else if (!email.match(mailformat)) {
          $("#email").addClass("error_msg");
          $(".valid_mail").slideDown();
          e.preventDefault();
        } else {
          $("#email").removeClass("error_msg");
          $(".valid_mail").slideUp();
        }
  
        // if ($("#guardian_email").is(":visible")) {
        //   if (guardian_email == "") {
        //     $("#guardian_email").addClass("error_msg");
        //     $(".hide").slideDown();
        //     e.preventDefault();
        //   } else if (!guardian_email.match(mailformat)) {
        //     $("#guardian_email").addClass("error_msg");
        //     $(".valid_mail").slideDown();
        //     e.preventDefault();
        //   } else {
        //     $("#guardian_email").removeClass("error_msg");
        //     $(".valid_mail").slideUp();
        //   }
        // }
  
        if (patient_phone == "") {
          $("#patient-phone").addClass("error_msg");
          $(".hide").slideDown();
          e.preventDefault();
        } else {
          $("#patient-phone").removeClass("error_msg");
        }
  
        if (month == "") {
          $("#month").addClass("error_msg");
          $(".hide").slideDown();
          e.preventDefault();
        } else {
          $("#month").removeClass("error_msg");
        }
  
        if (day == "") {
          $("#day").addClass("error_msg");
          $(".hide").slideDown();
          e.preventDefault();
        } else {
          $("#day").removeClass("error_msg");
        }
  
        if (year == "") {
          $("#year").addClass("error_msg");
          $(".hide").slideDown();
          e.preventDefault();
        } else {
          $("#year").removeClass("error_msg");
        }
  
        if (gender == "") {
          $("#gender").addClass("error_msg");
          $(".hide").slideDown();
          e.preventDefault();
        } else {
          $("#gender").removeClass("error_msg");
        }
  
        if (address == "") {
          $("#address").addClass("error_msg");
          $(".hide").slideDown();
          e.preventDefault();
        } else {
          $("#address").removeClass("error_msg");
        }
  
        if (city == "") {
          $("#city").addClass("error_msg");
          $(".hide").slideDown();
          e.preventDefault();
        } else {
          $("#city").removeClass("error_msg");
        }
  
        if (zip_code == "") {
          $("#zip-code").addClass("error_msg");
          $(".hide").slideDown();
          e.preventDefault();
        } else {
          if (zip_code.length < 5) {
            $("#zip-code").addClass("error_msg");
            $(".valid_zip").slideDown();
            e.preventDefault();
          } else {
            $("#zip-code").removeClass("error_msg");
            $(".valid_zip").slideUp();
          }
        }
  
        if (state == "") {
          $("#state").addClass("error_msg");
          $(".hide").slideDown();
          e.preventDefault();
        } else {
          $("#state").removeClass("error_msg");
        }
  
        if (country == "") {
          $("#country").addClass("error_msg");
          $(".hide").slideDown();
          e.preventDefault();
        } else {
          $("#country").removeClass("error_msg");
        }
      }
    );
  }

  // if the product is a subscription
  if ($('.product-form__submit').length > 0 && $('.SubAddToCart').length > 0) {
    $(document).on("click", ".product-form__submit, .SubAddToCart", function (e) {
  
      const email = $("#email").val();
      const email_format = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
      const precision_id = $("#precision_id").val();
      const precision_format1 = /^[A-Za-z]{2}-?\d{5}-?\d{5}$/;
      const precision_format2 = /^NG-?[A-HJ-NP-XZa-hj-np-xz1-9]{9}[A1-9]$/;
  
      if (email == "") {
        $("#email").addClass("error_msg");
        $(".hide").slideDown();
        e.preventDefault();
      } else if (!email.match(email_format)) {
        $("#email").addClass("error_msg");
        $(".valid_mail").slideDown();
        e.preventDefault();
      } else {
        $("#email").removeClass("error_msg");
        $(".valid_mail").slideUp();
      }
  
      const precisionIdField = document.getElementById("precision_id");
      let isPrecisionIdProduct =
        precisionIdField !== null && precisionIdField !== undefined;
  
      if (isPrecisionIdProduct) {
        if (precision_id == "") {
          $("#precision_id").addClass("error_msg");
          $(".hide").slideDown();
          e.preventDefault();
        } else if (
          !precision_id.match(precision_format1) &&
          !precision_id.match(precision_format2)
        ) {
          $("#precision_id").addClass("error_msg");
          $(".valid_precisionId").slideDown();
          e.preventDefault();
        } else {
          $("#precision_id").removeClass("error_msg");
          $(".valid_precisionId").slideUp();
        }
      } else {
        $("#precision_id").removeClass("error_msg");
        $(".valid_precisionId").slideUp();
      }
    });
  }

});
